import { Avatar, Stack, Typography } from '@mui/material';
import { useUpdatePersonalDetailsDictionary } from 'Hooks/useUpdatePersonalDetailsDictionary';
import { MaleIcon, FemaleIcon } from 'Images';
import { format } from 'date-fns';

interface IChildCard {
  child: {
    isBoy: boolean;
    firsName: string;
    lastName: string;
    idNumber: string;
    birthDate: Date;
  };
}

export const ExistingChildCard = ({ child }: IChildCard) => {
  const dictionary = useUpdatePersonalDetailsDictionary().addChild;

  return (
    <Stack
      boxShadow={'none'}
      borderRadius={'12px'}
      bgcolor={'purple2.shade_50'}
      border={'1px solid'}
      borderColor={'purple2.shade_100'}
      padding={'16px'}
      tabIndex={0}
      gap={'20px'}
      component='fieldset'
    >
      <legend>{`${child.firsName || ''} ${child.lastName || ''}`}</legend>
      <Stack direction={'row'} gap={'12px'}>
        <Avatar
          src={child.isBoy ? MaleIcon : FemaleIcon}
          alt=''
          sx={{
            width: '32px',
            height: '32px',
            position: 'relative',
            top: '-5px',
          }}
        />
        <Stack gap={'8px'}>
          <Typography
            role='heading'
            variant={'body4'}
            textOverflow={'elipsis'}
            overflow={'hidden'}
            whiteSpace={'nowrap'}
          >
            {`${child.firsName || ''} ${child.lastName || ''} `}(
            {child.isBoy ? dictionary.child.boy : dictionary.child.girl})
          </Typography>
          <Stack direction={'row'} gap={'24px'}>
            <Stack width={'auto'}>
              <Typography variant={'body6'} tabIndex={0}>
                {dictionary.idNumber}
              </Typography>
              <Typography
                variant={'body2'}
                textOverflow={'elipsis'}
                overflow={'hidden'}
                whiteSpace={'nowrap'}
              >
                {child.idNumber || ''}
              </Typography>
            </Stack>
            <Stack width={'auto'}>
              <Typography variant={'body6'} tabIndex={0}>
                {dictionary.dob}
              </Typography>
              <Typography variant={'body2'}>
                {child.birthDate
                  ? format(new Date(child.birthDate), 'dd.MM.yyyy')
                  : ''}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
